import Vue from 'vue'
import App from './App.vue'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import '@mdi/font/css/materialdesignicons.css'
import '@/assets/styles.css'
import router from './router'
import AyudanteSesion from './Servicios/AyudanteSesion'

Vue.use(Buefy)

Vue.mixin({
  methods: {
    can: AyudanteSesion.can(),
  },
})

Vue.config.productionTip = false

// ── Manejador global de errores de promesas ───────────────────────────────
// Captura cualquier Error lanzado por HttpService (errores del servidor)
// que no haya sido atrapado localmente con .catch(), y muestra un toast
// con el mensaje legible. Así ningún componente necesita manejar errores
// de red/servidor por su cuenta.

window.addEventListener('unhandledrejection', (evento) => {
  const error = evento.reason

  // Marcar como manejado para que no aparezca en consola como "Uncaught"
  evento.preventDefault()

  const mensaje = (error instanceof Error && error.message)
    ? error.message
    : 'Ocurrió un error inesperado. Por favor intenta de nuevo.'

  Vue.prototype.$buefy.notification.open({
    message: `<strong>Error</strong><br>${mensaje}`,
    type: 'is-danger',
    position: 'is-top-right',
    duration: 6000,
    hasIcon: true,
    icon: 'alert-circle',
  })
})

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')

